// extracted by mini-css-extract-plugin
export default {"container":"Statistics_container__YapDE","userCount":"Statistics_userCount__aohVQ","containerForThreeRows":"Statistics_containerForThreeRows__kuzD7"};